/**
 * Check if device is mobile and then run mutations Variant B Template
 */
function initMobileMutations(){
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    if(isMobile){
        movingElements();
        mutateSlider();
    }
}

window.addEventListener('resize', (e) => {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    if(isMobile){
        mutateSlider();
    }
});

/**
 * This would hidde variant A sections
 * And apply dataset attribute for variant b sections
 */
function hiddeSections () {
    const sections = document.querySelectorAll('.pdp-variant-b');
    sections.forEach((section) => {
        section.dataset.test = 'true'

        if(isHidden(section)){
            section.style.display = 'block';
        }
    });
}

// Where el is the DOM element you'd like to test for visibility
function isHidden(el) {
    return (el.offsetParent === null)
}

function setIntervalX(callback, delay, repetitions) {
    var x = 0;
    var intervalID = window.setInterval(function () {

       callback();

       if (++x === repetitions) {
           window.clearInterval(intervalID);
       }
    }, delay);
}

/**
 * Mutate Slider and re init
 */
function mutateSlider(){
    let mainSlider = document.querySelector('[data-main-media]');
    let mainSliderInstance = Flickityt4s.data(mainSlider);
    if(mainSliderInstance){
        mainSliderInstance.destroy();
    }

    let options = JSON.parse(mainSlider.getAttribute('data-flickityt4s-js'));
    options.pageDots = true;
    options.wrapAround = false;
    options.thumbNav = false;
    options.thumbVertical = false;

    new Flickityt4s(mainSlider, options);
    console.log('Experiment Running Action: Slider Mutated');
    //Hiding Nav
    document.querySelector('[data-thumb__scroller]').style.display = 'none';
}

//Moving elements
function movingElements(){
    let targetDiv = document.querySelector('.t4s-container.pdp-variant-b.is--layout_default');
    let elements = document.querySelectorAll('.t4s-product__title,.t4s-product__price-review')
    let wrapper = document.createElement('div');
    wrapper.classList.add('pdp-variant-b','wrapper-section');

    waitForElm('[data-yotpo-instance-id]:not(.yotpo-widget-instance)').then((elm) => {
        elements.forEach(element => {
            wrapper.appendChild(element);
        });

        wrapper.appendChild(elm);
        targetDiv.insertAdjacentElement('beforebegin', wrapper);
    })
}

// Utility to wait for Elements
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

/**
 * Callback function for Google Optimize
 * @param {String} value - Current Variant 
 */
function startTest(value){
    //Variant B
    console.log('Callback Running');
    if(value === '1'){
        console.log('Experiment Running: PDP Optimization')
        hiddeSections();
        initMobileMutations();
    }
}

document.addEventListener('DOMContentLoaded', (e) => {
    startTest('1');
});

// function gtag() {dataLayer.push(arguments)}
// gtag('event', 'optimize.callback', {
//     name: '2ULB2SW8SM-mWU2AEjX8bg',
//     callback: startTest
// });